import axios from '../utils/axios';
import { config } from '../utils/config';

export const getDoctor = () => {
    const url = `/prod/fhir/PractitionerRole?_include=*&organization=${config.organizationID}&role=doctor`;
    return axios.get(url).then((response) => {
        return response;
    });
};
